// extracted by mini-css-extract-plugin
export default {"close":"PL8ke-EhL-VL6vrnPPKvaOYXtRvaG8L693KQU4hbCgQ=","icon":"OHdOJQW38gKTa1n6RO3SbiXm470nOx4AVVkBIzqURZY="};